define('app/visualizations/MonitorNameCell',['require','glu/itemView','hbs!./MonitorNameCell.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		tpl = require('hbs!./MonitorNameCell.hbs');

	/**
	 * Renders a report name as text that is both formatted and clickable.
	 */
	return ItemView.extend({
		template: tpl,
		tagName: 'td',
		className: '',

		initialize: function(options) {
			ItemView.prototype.initialize.call(this, options);
			this.column = options.column;
		}
	});
});

